// Libs
import styled from "styled-components";

// Images
import bgTv from "../images/registration-bg-tv.jpg";
import bgDesktop from "../images/registration-bg-desktop.jpg";
import bgTablet from "../images/registration-bg-tablet.jpg";
import bgMobile from "../images/registration-bg-mobile.jpg";

const PageContainer = styled.div`
  /* Center PageContainer on the middle of screen*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  /* Changing the Divider component style */
  .Divider__container {
    margin: 26px 0;
  }

  /* Changing the SignUpFormContainer component style */
  form {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    button {
      padding: 10px 50px !important;
      font-size: 0px !important;

      :after {
        font-size: 18px !important;
        visibility: visible;
        padding: 15px 50px;
        top: 0;
        left: 0;
        content: "Sign up";
      }
    }
  }

  /* Hiding the category select field if the categorySelector props is true */
  .Signup__form-top-categories {
    display: ${props =>
      props.categorySelector === true ? "none" : "inline-block"};
  }
`;

const FakeModal = styled.div`
  width: 480px;
  padding: 24px;
  max-width: 100%;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 4px 40px 0 rgba(34, 41, 57, 0.25);
  position: relative;
  z-index: 2;
  margin: 32px auto;

  /* Changing the SocialButton and signup button style */
  button,
  a {
    width: 320px;
    max-width: 100%;
  }
`;

const SignInButton = styled.button`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.71;
  color: #ffffff;
  position: relative;
  z-index: 2;
  margin-top: -16px;
  margin-bottom: 32px;

  background: none;
  border: none;
  cursor: pointer;
  outline: inherit;
`;

const BackgroundImage = styled.div`
  /* Set up proportionate scaling */
  background-color: #555557;
  background-size: cover;
  background-position: left;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  /* Set rules to fill background based on resolution */
  @media (min-width: 1920px) {
    background-image: url(${bgTv});
  }

  @media (max-width: 1920px) {
    background-image: url(${bgDesktop});
  }

  @media (max-width: 768px) {
    background-image: url(${bgTablet});
  }

  @media (max-width: 425px) {
    background-image: url(${bgMobile});
  }
`;

const SocialButtonContainer = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;

  /* Selecting the first SocialButton component */

  .SocialButton {
    img {
      float: left;
    }
  }

  /* Gmail button */
  .SocialButton:nth-of-type(1) {
    margin-bottom: 16px;
    background-color: #e6e8f0;
  }

  /* Facebook button */
  .SocialButton:nth-of-type(2) {
    margin-bottom: 16px;
    color: white;
    background-color: #3b5998;

    img {
      filter: brightness(5);
    }
  }
`;

const Header = styled.div`
  text-align: center;
`;

const Title = styled.div`
  margin: 18px 0;
  line-height: 1;
  color: #222939;
  font-size: 32px;
  font-weight: bold;
`;

const Subtitle = styled.div`
  max-width: 100%;
  width: 300px;
  color: #222939;
  font-size: 20px;
  line-height: 1.2;
  font-weight: bold;
  font-style: normal;
  text-align: center;
  margin-bottom: 16px;
  font-stretch: normal;
  letter-spacing: normal;

  span {
    color: #8144e5;
  }

  div:nth-of-type(1) {
    margin-left: -38px;
  }

  div:nth-of-type(2) {
    text-align: right;
    /* Selecting the last image into the Subtitle component (iconFlags) */
    img {
      margin-left: 8px;
    }
  }
`;

const SubtitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export {
  Title,
  Header,
  Subtitle,
  FakeModal,
  SignInButton,
  PageContainer,
  BackgroundImage,
  SubtitleContainer,
  SocialButtonContainer
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/RegistrationStyle.js